import { connect } from 'react-redux'

import DriverKeyModal from '../../../pages/settings/components/Modals/DriverKeyModal'
import {
  getDriversOptimiserIsLoading,
  getDrivers,
  getDriversOptimiserCount,
} from '../../../redux/driver/selectors'

import { fetchDriversWarrning } from '../../../redux/driver/actions'
import {
  assignToDriver,
  fetchKeys,
  getKeysMore,
  onSearchKeys,
  pageChanged,
} from '../../../redux/configuration/actions'
import {
  getConfigSuccess,
  getErrorMessageConfig,
  getIsLoadingAssign,
  getKeys,
  getKeysCount,
  getKeysListIsLoading,
} from '../../../redux/configuration/selectors'

const mapStateToProps = (state) => ({
  drivers: getDrivers(state),
  isLoadingDrivers: getDriversOptimiserIsLoading(state),
  driversCount: getDriversOptimiserCount(state),
  keys: getKeys(state),
  isLoadingAssign: getIsLoadingAssign(state),
  success: getConfigSuccess(state),
  errorMessage: getErrorMessageConfig(state),
  isLoadingKeysList: getKeysListIsLoading(state),
  keysCount: getKeysCount(state),
})

const mapDisptachToProps = (dispatch) => ({
  fetchDrivers: (filter) => dispatch(fetchDriversWarrning(filter)),
  fetchKeys: () => dispatch(fetchKeys()),
  searchKeys: (search) => {
    dispatch(onSearchKeys(search))
    dispatch(pageChanged(0))
    dispatch(fetchKeys())
  },
  fetchMoreKeys: (offset) => {
    dispatch(pageChanged(offset))
    dispatch(getKeysMore())
  },
  assign: (data) => dispatch(assignToDriver(data)),
})

export default connect(mapStateToProps, mapDisptachToProps)(DriverKeyModal)
